export default __webpack_public_path__ + "static/crm-features-list-f1fb413fd9ab33db16b4afd788c3b252.png";